import { Component, computed, OnDestroy } from "@angular/core";

import { AssetTypeNavigationService, RoleService } from "@rvi/asset-modules";
import LiveAssetsStateService from "../_services/live-assets-state.service";

@Component({
  selector: "app-asset-type-page",
  templateUrl: "./asset-type-page.component.html",
  styleUrl: "./asset-type-page.component.scss",
  standalone: false
})
export class AssetTypePageComponent implements OnDestroy {
  public createAssetTypeDisabled = computed(() => this.assetTypeNavigation.isViewerPage() || !this.canCreateAssetType);
  private canCreateAssetType = false;

  constructor(
    private assetTypeNavigation: AssetTypeNavigationService,
    private assetModuleRoleService: RoleService,
    private liveAssetsStateService: LiveAssetsStateService
  ) {
    this.canCreateAssetType = this.assetModuleRoleService.canI("CreateAssetType");
  }

  ngOnDestroy(): void {
    this.liveAssetsStateService.init().subscribe();
  }

  addAssetType() {
    this.assetTypeNavigation.createNewAssetType();
  }
}
